/** Barrel import for all per-tree attunement JSON definitions (V4 format). */
import type { V4TreeDefinition } from '../../utils/Types';
import grit from './grit.json';
import specter from './specter.json';
import fire from './fire.json';
import blades from './blades.json';
import lightning from './lightning.json';
import earth from './earth.json';
import conjuration from './conjuration.json';
import poison from './poison.json';
import astral from './astral.json';

/** V4 tree definitions — single-path, fork-based, per-node XP thresholds. */
export const v4SkillTrees: Record<string, V4TreeDefinition> = {
  grit: grit as unknown as V4TreeDefinition,
  specter: specter as unknown as V4TreeDefinition,
  fire: fire as unknown as V4TreeDefinition,
  blades: blades as unknown as V4TreeDefinition,
  lightning: lightning as unknown as V4TreeDefinition,
  earth: earth as unknown as V4TreeDefinition,
  conjuration: conjuration as unknown as V4TreeDefinition,
  poison: poison as unknown as V4TreeDefinition,
  astral: astral as unknown as V4TreeDefinition,
};


